export default "__VITE_ASSET__D5naFGN1__"